<style lang="scss">
    @import "project";
</style>
<template>
    <div class="project-apply">
        <el-header class="app-header">
            <app-title homeUrl='/'></app-title>
            <app-logout></app-logout>
        </el-header>
         <el-main class="p-a-body">
             <div class="c-center" v-if="applyFlag || hasApplyProject">
                 <p><img src="img/apply-loading.png" /></p>
                 <p class="p-a-t1 c-main-color">项目申请已提交</p>
                 <p class="p-a-t2">系统管理员审核中，审核通过将会邮件通知到您。</p>
             </div>
            <div v-else>
                <div class="p-a-title c-main-color">
                    <p><img src="img/project-apply.png" /></p>
                    <p>申请开通项目</p>
                    <p>开启自助制图系统</p>
                </div>
                <el-form :model="myForm" ref="myForm" :rules="formRules" label-width="100px">
                    <el-form-item label="项目名称" prop="name">
                        <el-input spellcheck="false" type="name" v-model="myForm.name" class="p-a-item"></el-input>
                    </el-form-item>
                    <el-form-item label="管理员邮箱" prop="adminEmail">
                        <el-input spellcheck="false" type="email" v-model="myForm.adminEmail" class="p-a-item"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" round @click="submitForm('myForm')" class="p-a-item">立即申请</el-button>
                        <!--<el-button @click="resetForm('myForm')">重置</el-button>-->
                    </el-form-item>
                </el-form>
            </div>
         </el-main>
        <el-footer class="p-a-desc">
            如有疑问，可联系系统管理员POPO  hzwangdada@corp.netease.com
        </el-footer>
        <project-alert v-model="projectAlertVal"></project-alert>
    </div>
</template>
<script>
    import appTitle from '@/views/layout/app-title';
    import appLogout from '@/views/layout/app-logout';
    import projectService from '../../request/service/project-service'
    import projectAlert from './project-repeatition-alert'
    import {error_code_40001} from '@/const.js'
    export default {
        components: {appTitle, appLogout, projectAlert},
        data (){
            var checkEmail = (rule, value, callback) => {
                const mailReg = /^\w+((.\w+)|(-\w+))+@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+)((.|-)[A-Za-z0-9]+)+$/;
                if (mailReg.test(value)) {
                    callback()
                } else {
                    callback(new Error('请输入正确的邮箱格式'));
                }
            };
            let applyFlag = this.$route.query.applyFlag || false;
            return {
                applyFlag: applyFlag,
                projectAlertVal: false,
                myForm: {
                    name: '',
                    adminEmail: '',
                },
                formRules: {
                    name: [
                        { required: true, message: '项目不能为空', trigger: 'blur' },
                    ],
                    adminEmail: [
                        { required: true, message: '邮箱不能为空', trigger: 'blur' },
                        {validator: checkEmail, trigger: 'blur'}
                    ],
                }
            }
        },
        computed: {
            hasApplyProject () {
                let projectApplyList = this.$store.state.app.loginUser.projectApplyList;
                return projectApplyList && projectApplyList.length > 0
            }
        },
        watch:{
            hasApplyProject:{
                handler(v){
                    this.applyFlag = v;
                    if(v){
                        this.$message.success('项目申请已提交，等待管理员审核');
                    }
                },
                immediate: true
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                       this.submitProjectApply();
                    } else {
                        return false;
                    }
                });
            },
            submitProjectApply () {
                projectService.applyProject(this.myForm).then(() =>{
                    this.applyFlag = true;
                    this.$router.push({
                        query: {
                            applyFlag: true
                        }
                    });
                }, (error) => {
                    if (error.code === error_code_40001) {
                        this.projectAlertVal = true;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>